import { Zap } from "../../../../icons"
import type { CompactionEvent } from '@lens/types/claude'
import { formatTokens } from '@lens/lib/decode'
import { Card } from '../../../../card'
import { formatDateTime } from '../../../../format'

export function CompactionCard({ event }: { event: CompactionEvent }) {
 return (
 <Card className="my-3 bg-muted px-4 py-3">
 <div className="flex items-center gap-2 text-foreground type-body mb-1">
 <Zap className="w-3.5 h-3.5 shrink-0" strokeWidth={1.5} />
 <span>CONTEXT COMPACTION</span>
 <span className="ml-auto text-foreground font-normal">
 {formatDateTime(event.timestamp)}
 </span>
 </div>
 <div className="flex gap-4 type-body text-foreground">
 <span>trigger: <span className="text-foreground ">{event.trigger}</span></span>
 <span>context before: <span className="text-foreground ">{formatTokens(event.pre_tokens)} tokens</span></span>
 </div>
 {event.summary && (
 <p className="mt-1.5 type-body text-foreground italic line-clamp-2">
 &ldquo;{event.summary}&rdquo;
 </p>
 )}
 </Card>
 )
}
